// extracted by mini-css-extract-plugin
export var newsletter__input = "NewsletterForm-module--newsletter__input--91517";
export var newsletter__input__container = "NewsletterForm-module--newsletter__input__container--f7cca";
export var newsletter__input__email = "NewsletterForm-module--newsletter__input__email--25019";
export var newsletter__send = "NewsletterForm-module--newsletter__send--fd8cd";